import SEOHead from '@components/SEOHead';
import Header from '@components/layout/Header';
import { MainSection } from '@components/LandingElements/MainSection';
import React from 'react';
import { Footer } from '@components/layout/Footer';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SimpleFaq } from '@components/LandingElements/SimpleFAQ';
import { CtaBtn } from '@components/LandingElements/CtaBtn';
import { FeatureRightImgSection } from '@components/LandingElements/FeatureSection/FeatureRightImgSection';
import { FeatureLeftImgSection } from '@components/LandingElements/FeatureSection';
import { StepsSection } from '@components/LandingElements/FeatureSection/StepsSection';

export default function NsfwAiRoleplay() {
  const faqContent = [
    {
      question: 'What is NSFW AI roleplay?',
      answer:
        'NSFW AI roleplay involves interactive, adult-themed scenarios with AI characters, where users can engage in explicit conversations and actions dictated by their fantasies and desires, all powered by advanced AI technology.',
    },
    {
      question: 'How can I customize my NSFW AI roleplay experience?',
      answer:
        'You can customize your NSFW AI roleplay by choosing characters, scenarios, and settings from our extensive catalog. Adjust the storyline, character traits, and visual settings using our AI image generator to match your personal preferences.',
    },
    {
      question: 'Are the AI characters and scenarios diverse?',
      answer:
        'Absolutely! Our catalog includes a wide range of AI characters from different backgrounds and stories, including everything from shy students to more daring characters like Yakuza daughters. Each character offers a unique experience for the perfect AI NSFW roleplay.',
    },
    {
      question: 'Can I replay different scenarios with the same AI girl?',
      answer:
        'Yes, all roleplay chats are replayable, allowing you to explore different outcomes with the same AI girl. Each session can lead to a new and unique storyline based on your choices.',
    },
    {
      question:
        'What types of visuals can I create with the AI image generator?',
      answer:
        ' Our AI image generator lets you create detailed visuals of your AI girl, including her environment, poses, and expressions. Whether it’s a romantic date or an adventurous encounter, you can vividly picture each scenario.',
    },
    {
      question: 'How do I ensure my interactions remain private?',
      answer:
        'Privacy is our priority. All interactions, including chat histories and generated images, are securely stored and accessible only to you, ensuring that your adventures remain confidential.',
    },
  ];
  return (
    <>
      <SEOHead
        title="NSFW AI Roleplay with Hot Girls"
        description="Immersive NSFW AI Roleplay with Wild Stories: Roleplay in chat, create and customize AI images, and create your perfect AI girlfriend. Try for free!"
        type="website"
        keywords="nsfw ai roleplay, nsfw roleplay ai, ai nsfw roleplay, ai roleplay nsfw, roleplay ai nsfw"
        url="https://www.aigirlfriend.wtf/nsfw-ai-roleplay"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header />
      <main>
        <MainSection
          title={
            <>
              Ultimate{' '}
              <span className="!leading-none text-wtf-persianRed">
                <br />
                NSFW AI Roleplay
                <br />
              </span>
            </>
          }
          subTitle={
            'Looking for an NSFW AI roleplay tool with unlimited possibilities?'
          }
          mainText={
            'Your search is over! Discover the AI Girlfriend WTF platform, featuring a catalog packed with wild NSFW AI roleplay scenarios and vivid images!'
          }
          imgSrc={'/sections/nsfw-ai-roleplay/main.webp'}
          imgSrcMobile={'/sections/nsfw-ai-roleplay/main.webp'}
          ctaLink={'/ai-girls'}
          ctaText={'Try Free'}
        />
        <StepsSection
          title={'How to play NSFW AI Roleplay'}
          imgSrc={'/sections/nsfw-ai-roleplay/create-gf-laptop.png'}
          imgAlt={'A few ai girls photos floating over laptop'}
          stepOneTitle={'Choose NSFW AI Roleplay from Our Catalog'}
          stepOneSection={
            <p className="text-wtf-white">
              Explore our diverse AI characters, each with a unique story. Try
              out the filter tag &apos;adventure&apos;! How about adopting a cat
              girl from a shelter who barely speaks? Or meeting a Yakuza
              boss&apos;s daughter with a spicy temper? With over 100 scenarios,
              experience them all!
            </p>
          }
          stepTwoTitle={'Join AI Roleplay Fun'}
          stepTwoSection={
            <p className="text-wtf-white">
              Dive into immersive AI roleplay: be a hero, or perhaps a villain
              this time? All chats are replayable, and each story can unfold
              very differently. Here, everything depends on you, allowing you to
              fulfill even your darkest fantasies with our advanced AI chatbot.
            </p>
          }
          stepThreeTitle={'Create and Customize AI Art'}
          stepThreeSection={
            <p className="text-wtf-white">
              Ever dreamt of the perfect date night? Maybe you&apos;re the hero
              who saves her in the jungle? Or a playboy millionaire taking a
              homeless girl out? Here, you can visualize exactly what your AI
              girl does: how she looks, her emotions, and where this all happens
              with our AI image generator.
            </p>
          }
        />
        <br />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Free'} />
        </div>
        <FeatureRightImgSection
          title={'Extensive NSFW Roleplay AI Catalog'}
          imgSrc={'/sections/uncensored-ai/dreamy.jpeg'}
          imgAlt={'Asial ai girl with cat ears'}
          textStructure={
            <p>
              Now, you have the power to create your very own AI girlfriend:
              choose her appearance and personality. But, even if you create two
              girls with the same options, they will be different! Our advanced
              AI tool ensures they&apos;re unique, making every playthrough of
              our AI porn games replayable and filled with a myriad of emotions.
            </p>
          }
        />
        <FeatureLeftImgSection
          redTitle={'Create ideal AI Character for AI Roleplay'}
          sectionTitle={'Craft Your Own Perfect AI Girl'}
          imgSrc={'/sections/spicy-chat-ai/baseball.webp'}
          imgAlt={''}
          textStructure={
            <>
              <p className={'text-xs'}>
                Luckily for you, our advanced AI girl generator allows
                customization of personality (including hobbies and kinks) and
                appearance. We support anime-style AI girls and realistic ones.
                Each created AI girl is private to you only and comes with an AI
                image generator!
              </p>
            </>
          }
        />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Free'} />
        </div>
        <br />
        <br />
        <br />
        <SimpleFaq
          content={faqContent}
          ctaText={'Try Free'}
          ctaLink={'/ai-girls'}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
